var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLayoutColumnsTall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 62,
    height: 14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 20,
    height: 48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 15,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 20,
    height: 48
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 22,
    height: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutColumnsTall);
export default __webpack_public_path__ + "static/media/icon-layout-columns-tall.d0dc85b42b267333f3b0a60e7cddde17.svg";
export { ForwardRef as ReactComponent };